(function () {
  const RATE_URL = 'https://open.er-api.com/v6/latest/USD';
  const CACHE_KEY = 'tcgshops_usd_eur_rate';
  const REFRESH_INTERVAL = 5 * 60 * 1000;

  function parseCachedRate() {
    try {
      const cached = JSON.parse(window.localStorage.getItem(CACHE_KEY) || 'null');
      if (!cached || typeof cached.rate !== 'number' || typeof cached.timestamp !== 'number') return null;
      if (Date.now() - cached.timestamp > REFRESH_INTERVAL) return null;
      return cached.rate;
    } catch (error) {
      return null;
    }
  }

  function cacheRate(rate) {
    try {
      window.localStorage.setItem(CACHE_KEY, JSON.stringify({ rate, timestamp: Date.now() }));
    } catch (error) {
      // Ignore storage errors; the UI can still update for this page view.
    }
  }

  function getFallbackRate() {
    const estimate = document.querySelector('[data-fallback-rate]');
    if (!estimate) return null;

    const fallbackRate = Number(estimate.getAttribute('data-fallback-rate'));
    return Number.isFinite(fallbackRate) && fallbackRate > 0 ? fallbackRate : null;
  }

  function formatEuro(amount) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'EUR',
    }).format(amount);
  }

  function updateEstimates(rate) {
    document.querySelectorAll('[data-usd-cents]').forEach((estimate) => {
      const usdCents = Number(estimate.getAttribute('data-usd-cents'));
      if (!Number.isFinite(usdCents)) return;

      const eurAmount = (usdCents / 100) * rate;
      const valueElement = estimate.querySelector('.usd-eur-estimate__eur');
      if (valueElement) valueElement.textContent = `Approx. ${formatEuro(eurAmount)} EUR`;
    });
  }

  async function fetchRate() {
    const response = await fetch(RATE_URL, { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to fetch USD to EUR rate');

    const data = await response.json();
    const rate = Number(data && data.rates && data.rates.EUR);
    if (!Number.isFinite(rate) || rate <= 0) throw new Error('Invalid USD to EUR rate');

    cacheRate(rate);
    return rate;
  }

  async function refreshEstimates() {
    if (!document.querySelector('[data-usd-cents]')) return;

    const cachedRate = parseCachedRate();
    if (cachedRate) {
      updateEstimates(cachedRate);
      return;
    }

    try {
      updateEstimates(await fetchRate());
    } catch (error) {
      const fallbackRate = getFallbackRate();
      if (fallbackRate) updateEstimates(fallbackRate);
    }
  }

  document.addEventListener('DOMContentLoaded', refreshEstimates);
  document.addEventListener('shopify:section:load', refreshEstimates);
  new MutationObserver((mutations) => {
    const hasNewEstimate = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false;
        return node.matches('[data-usd-cents]') || Boolean(node.querySelector('[data-usd-cents]'));
      })
    );

    if (!hasNewEstimate) return;

    window.clearTimeout(window.usdEurEstimateRefreshTimer);
    window.usdEurEstimateRefreshTimer = window.setTimeout(refreshEstimates, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(refreshEstimates, REFRESH_INTERVAL);
})();
